import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { isIntegrationStyleFunnel } from "@/lib/deals-funnel-filter";
import type { SalesFunnel } from "@/types/lead";

export function useDealsFunnelMemberships(
  workspaceId: string | null,
  funnelId: string | null,
  funnel: SalesFunnel | undefined,
) {
  const useMembership = isIntegrationStyleFunnel(funnel);

  return useQuery({
    queryKey: ["deals-funnel-memberships", workspaceId, funnelId, useMembership],
    queryFn: async (): Promise<Set<string>> => {
      if (!workspaceId || !funnelId || !useMembership) return new Set();
      const { data, error } = await supabase
        .from("lead_funnel_memberships")
        .select("lead_id")
        .eq("funnel_id", funnelId);
      if (error) throw error;
      return new Set((data ?? []).map(row => String(row.lead_id)));
    },
    enabled: !!workspaceId && !!funnelId && useMembership,
    staleTime: 60_000,
  });
}
